var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-wrap"},[_c('div',{staticClass:"index-bar"},_vm._l((_vm.bars),function(bar){return _c('a',{key:bar,staticClass:"item",attrs:{"href":'#' + bar.replace(/\s+/g, '')},on:{"click":function($event){$event.preventDefault();return _vm.anchorJump('#' + bar)}}},[_vm._v(_vm._s(bar))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45af7f5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/investor/components/index-bar.vue
// module id = null
// module chunks = 